import { LoadingContainer } from 'peach/components'
import { useParams, useHistory } from 'peach/router'

import {
  ConfirmDialog,
  Clickable,
  DynamicForm,
  Page,
  PageHeader,
} from 'core/components'
import {
  useGetWorkitemTypeById,
  useUpdateWorkitemType,
  useDeleteWorkitemType,
} from 'core/types'
import { workflowItemTypeSchema } from 'core/utils/generated/formSchemas'

const WorkflowItemType = () => {
  const history = useHistory()
  const { companyId, workflowWorkitemTypeId } = useParams<{
    companyId?: string
    workflowWorkitemTypeId?: string
  }>()

  const { data: workitemType, isLoading } = useGetWorkitemTypeById({
    companyId,
    workflowWorkitemTypeId,
  })

  const { mutateAsync: updateWorkitemType } = useUpdateWorkitemType({
    companyId,
    workflowWorkitemTypeId,
  })

  const { mutateAsync: deleteWorkitemType } = useDeleteWorkitemType({
    companyId,
    workflowWorkitemTypeId,
  })

  return (
    <LoadingContainer isLoading={isLoading}>
      <Page variant='full'>
        <PageHeader
          title={workitemType?.descriptionShort || 'Workflow Item Type'}
        />
        <DynamicForm
          data={workitemType || {}}
          fieldEditMode='toggle'
          onSubmit={async (payload: any) => {
            await updateWorkitemType(payload)
          }}
          otherActions={[
            <ConfirmDialog
              key='delete-action'
              onConfirm={async () => {
                await deleteWorkitemType()
                history.push(`/companies/${companyId}/workflow-item-types`)
              }}
              title='Delete Workflow Item Type'
            >
              <Clickable variant='outline'>Delete</Clickable>
            </ConfirmDialog>,
          ]}
          schema={workflowItemTypeSchema}
        />
      </Page>
    </LoadingContainer>
  )
}

export default WorkflowItemType
